"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CMS_SIZING = void 0;
var CMS_SIZING = /*#__PURE__*/function (CMS_SIZING) {
  CMS_SIZING[CMS_SIZING["size25"] = 25] = "size25";
  CMS_SIZING[CMS_SIZING["size33"] = 33] = "size33";
  CMS_SIZING[CMS_SIZING["size50"] = 50] = "size50";
  CMS_SIZING[CMS_SIZING["size66"] = 66] = "size66";
  CMS_SIZING[CMS_SIZING["size75"] = 75] = "size75";
  CMS_SIZING[CMS_SIZING["size100"] = 100] = "size100";
  return CMS_SIZING;
}({});
exports.CMS_SIZING = CMS_SIZING;